import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AppVersionService } from '../../../core/services/app-version.service';

const PRODUCT_TERMS_PATHS = [
  '/install-terms',
  '/equipment-terms',
  '/renewal-terms',
] as const;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule]
})
export class FooterComponent {
  private readonly versionService = inject(AppVersionService);
  private readonly router = inject(Router);

  private readonly urlPath = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  /** Standalone product terms: hide platform Terms/Privacy footer links. */
  protected readonly showLegalLinks = computed(() => {
    const path = (this.urlPath() ?? '').split('?')[0];
    return !PRODUCT_TERMS_PATHS.some(p => path === p || path.startsWith(`${p}/`));
  });

  // Dynamic copyright year (2025-{currentYear})
  get copyrightYear(): string {
    const currentYear = new Date().getFullYear();
    return currentYear === 2025 ? '2025' : `2025-${currentYear}`;
  }

  // Get current app version
  get appVersion(): string {
    return this.versionService.getCurrentVersionString();
  }
}
